export const USER_IDS_ORDER_SET = 'at/userManagement/workAssignments/USER_IDS_ORDER_SET'
export const SET_LOADED = 'at/userManagement/workAssignments/SET_LOADED'
export const LOAD_USERS_DATA = 'at/userManagement/workAssignments/LOAD_USERS_DATA'
export const LOAD_USERS_DATA_SUCCESS = 'at/userManagement/workAssignments/LOAD_USERS_DATA_SUCCESS'
export const LOAD_USERS_DATA_FAILURE = 'at/userManagement/workAssignments/LOAD_USERS_DATA_FAILURE'
export const SET_SORTING = 'at/userManagement/workAssignments/SET_SORTING'
export const SET_USERS_FILTER = 'at/userManagement/workAssignments/SET_GROUPS_FILTER'
export const SET_WORDS_FILTER = 'at/userManagement/workAssignments/SET_WORDS_FILTER'
export const SET_SUBMITTED_WORDS_FILTER = 'at/userManagement/workAssignments/SET_SUBMITTED_WORDS_FILTER'
export const SET_USERS_PER_PAGE = 'at/userManagement/workAssignments/SET_USERS_PER_PAGE'
export const SET_PAGE_NUM = 'at/userManagement/workAssignments/SET_PAGE_NUM'
export const SET_WORK_ASSIGNMENTS_FILTER = 'at/userManagement/workAssignments/SET_WORK_ASSIGNMENTS_FILTER'
export const SET_USER_WORK_ASSIGNMENT_COUNTERS = 'at/userManagement/workAssignmnets/SET_USER_WORK_ASSIGNMENTS_COUNTER'
export const SET_USERS_WORK_ASSIGNMENTS_COUNTERS = 'at/userManagement/workAssignments/SET_USERS_WORK_ASSIGNMENTS_COUNTERS'
export const ADD_USER_WORK_ASSIGNMENTS_COUNTERS = 'at/userManagement/workAssignments/ADD_USER_WORK_ASSIGNMENTS_COUNTERS'
export const SET_LOADING = 'at/userManagement/workAssignments/SET_LOADING'



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/actionTypes.js